import React from 'react';

import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Hidden } from '@material-ui/core';

import Breadcrumbs from '@navigation/Breadcrumbs';
import { Input, FormBackground, FormContainer, ButtonsContainer, Button } from '@components/Forms';
import { Text, HiddenMobile } from '@components';
import { useForm, useUser } from '@hooks';

const UserNameEdit = ({ route }) => {
  const { t } = useTranslation();
  const history = useHistory();
  const {
    update,
    // eslint-disable-next-line camelcase
    selected: { patern_last, matern_last, first_name },
  } = useUser({ fetchUsers: false });
  const { formValues, handleInputChange, isValid, errors, isInitial } = useForm({
    first_name,
    patern_last,
    matern_last,
  });

  const handleSubmit = () => {
    if (!isValid()) return '';
    update(formValues);
  };

  return (
    <>
      <Hidden mdDown>
        <Breadcrumbs route={route} />
      </Hidden>
      <FormBackground>
        <FormContainer>
          <HiddenMobile>
            <Text type="H6-w400" color="gray800">
              {t('editname.subtitle')}
            </Text>
          </HiddenMobile>
          <Input
            id="first_name"
            testId="first_name-testId"
            label={t('editname.name')}
            value={formValues.first_name}
            onChange={handleInputChange}
            error={!!errors.first_name}
            caption={errors.first_name}
          />
          <Input
            id="patern_last"
            testId="patern_last-testId"
            label={t('editname.lastname')}
            value={formValues.patern_last}
            onChange={handleInputChange}
            error={!!errors.patern_last}
            caption={errors.patern_last}
          />
          <Input
            id="matern_last"
            testId="matern_last-testId"
            label={t('editname.mother_lastname')}
            value={formValues.matern_last}
            onChange={handleInputChange}
            error={!!errors.matern_last}
            caption={errors.matern_last}
          />
          <ButtonsContainer>
            <HiddenMobile>
              <Button
                type="outlined"
                id="btn-cancel"
                testId="btn-cancel-testId"
                onClick={() => history.goBack()}
              >
                {t('common.buttonCancel')}
              </Button>
            </HiddenMobile>
            <Button
              id="btn-submit"
              testId="btn-submit-testId"
              onClick={handleSubmit}
              disabled={isInitial()}
            >
              {t('editname.submitbutton')}
            </Button>
          </ButtonsContainer>
        </FormContainer>
      </FormBackground>
    </>
  );
};

export default UserNameEdit;
